import {ApolloLink} from '@apollo/client';
/* eslint-disable camelcase */
import {
  unstable_createOperationTypeSplitLink as createOperationTypeSplitLink,
  unstable_createVariableValueSplitLink as createVariableValueSplitLink,
} from '@sail/data';
import type {unstable_SchemaConfig as SchemaConfig} from '@sail/data';
/* eslint-enable camelcase */
import anonymousTypes from '../../../schema/anonymousTypes.json';
import topLevelFields from '../../../schema/topLevelFields';
import unionObjectTypesMap from '../../../schema/unionObjectTypesMap.json';
import fieldVersionOverrides from '../../../schema/fieldVersionOverrides.json';
import getPossibleTypes from '../../shared/graphql/utils/getPossibleTypes';
import pbeMap from '../../../schema/pbe';
import createV1ApolloLink from './createV1ApolloLink';
import topLevelFieldsInputTypes from '../../../schema/topLevelFieldsInputTypes';

const V1_CONTEXT_VARIABLE_SUFFIX = 'v1Context';

export default function getV1SchemaConfig(
  apolloLinks: ApolloLink[],
  shadowComparisonOperationsV1ToV2: Record<string, boolean>,
): SchemaConfig {
  const v1Link = createV1ApolloLink(
    unionObjectTypesMap,
    pbeMap,
    topLevelFieldsInputTypes,
    fieldVersionOverrides,
    shadowComparisonOperationsV1ToV2,
  );

  const queryLink = createVariableValueSplitLink(
    v1Link,
    V1_CONTEXT_VARIABLE_SUFFIX,
    topLevelFields.queries,
  );

  const mutationLink = v1Link;

  return {
    apolloLink: ApolloLink.from([
      ...apolloLinks,
      createOperationTypeSplitLink(mutationLink, queryLink),
    ]),
    possibleTypes: getPossibleTypes(unionObjectTypesMap),
    anonymousTypes,
    topLevelFields,
  };
}
